var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5602 30.2733L22.0573 24.7761C22.3873 24.4461 22.5523 24.2811 22.7426 24.2193C22.9099 24.1649 23.0902 24.1649 23.2576 24.2193C23.4479 24.2811 23.6129 24.4461 23.9429 24.7761L29.4033 30.2366M24.6667 25.5L27.0573 23.1095C27.3873 22.7795 27.5523 22.6145 27.7426 22.5526C27.9099 22.4982 28.0902 22.4982 28.2576 22.5526C28.4479 22.6145 28.6129 22.7795 28.9429 23.1095L31.3334 25.5M21.3334 20.5C21.3334 21.4205 20.5872 22.1667 19.6667 22.1667C18.7463 22.1667 18.0001 21.4205 18.0001 20.5C18.0001 19.5795 18.7463 18.8333 19.6667 18.8333C20.5872 18.8333 21.3334 19.5795 21.3334 20.5ZM18.6667 30.5H27.3334C28.7335 30.5 29.4336 30.5 29.9684 30.2275C30.4388 29.9878 30.8212 29.6054 31.0609 29.135C31.3334 28.6002 31.3334 27.9001 31.3334 26.5V19.5C31.3334 18.0999 31.3334 17.3998 31.0609 16.865C30.8212 16.3946 30.4388 16.0122 29.9684 15.7725C29.4336 15.5 28.7335 15.5 27.3334 15.5H18.6667C17.2666 15.5 16.5666 15.5 16.0318 15.7725C15.5614 16.0122 15.1789 16.3946 14.9392 16.865C14.6667 17.3998 14.6667 18.0999 14.6667 19.5V26.5C14.6667 27.9001 14.6667 28.6002 14.9392 29.135C15.1789 29.6054 15.5614 29.9878 16.0318 30.2275C16.5666 30.5 17.2666 30.5 18.6667 30.5Z",
    stroke: "#92969A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F9FAFB",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.54164562e649f5e91b72ae9c1c9c1f5b.svg";
export { ForwardRef as ReactComponent };